<template>
	<main class="page customer">
		<!--<div v-if="global.isAdminView" class="admin-view-data">
            Customer Id: {{ customer.id }}
            <br/>
            Editing CustomerId: {{ customer.id }}
        </div>-->
		<IsBusyScreenComponent v-if="isLoadingInitialSetup || isCreatingDeal" />
		<TabMenu
			v-if="!isLoadingInitialSetup"
			:tabs="tabs"
			:initialTab="tabs[0]"
			ref="tabMenu"
			:beforeChangeFunc="beforeTabChange"
			queryParam="t"
			@changeTab="afterTabChange"
		>
			<template v-slot:[`tab-head-${tabs[0]}`]>
				<span>Customer(s)</span>
				<button
					@click.stop="handleGoBack"
					class="close-button no-shadow deals"
				>
					<i class="far fa-times-circle"></i>
				</button>
			</template>

			<template
				v-for="(deal, index) in deals"
				v-slot:[`tab-head-${deal.id}`]
				:key="index"
			>
				<div class="closeTab">
					<span :key="index + 1">{{ deal.dealNumber }}</span>
					<button
						@click.stop="() => deleteDealConfirmation(deal)"
						class="close-button no-shadow deals"
					>
						<i class="far fa-times-circle"></i>
					</button>
				</div>
			</template>

			<template
				v-for="(deal, index) in deals"
				v-slot:[`tab-panel-${deal.id}`]
				:key="index"
			>
				<IsBusySectionComponent v-if="isLoadingDeal || !fimenu" />

				<CoBrowsingWrapper
					v-else
					:isCoBrowsingEnabled="isCoBrowsingEnabled"
					:dataToWatch="coBrowsingDataToWatch"
					:fimenu="fimenu as FIMenuClass"
					:isBusyLoadingDeal="isLoadingDeal"
				>
					<FIMenu
						:key="index"
						v-model:fimenu="fimenu"
						ref="fimenudeal"
					/>
				</CoBrowsingWrapper>
			</template>

			<template v-slot:[`tab-panel-${tabs[0]}`]>
				<CustomerDetailsHeader
					:customer="customer"
					v-model:selectedStoreCode="selectedStoreCode"
					v-model:selectedCustomerId="selectedCustomerId"
					v-model:selectedStore="selectedStore"
					:loadData="loadSelectedCustomerInformation"
					v-model:availableCustomers="availableCustomers"
					:customerStores="customerStores"
					v-model:isLoading="isLoading"
					:metadata="metadata"
					:createCustomer="createCustomer"
					:isCustomerCreating="isCustomerCreating"
					:addCustomersToAvailableCustomers="addCustomersToAvailableCustomers"
				/>

				<CustomerDetails
					:selectedStoreCode="selectedStoreCode"
					:selectedStore="selectedStore"
					v-model:customer="customer"
					:metadata="metadata"
					:selectedCustomerId="selectedCustomerId"
					:customerStores="customerStores"
					:createCustomer="createCustomer"
					:deals="deals"
					:maxDealsInTab="maxDealsInTab"
					:isLoading="isLoading || isLoadingTabChange"
					:openDeal="openDeal"
					:isCustomerCreating="isCustomerCreating"
				/>
			</template>
		</TabMenu>
	</main>
</template>
<script lang="ts">
	interface IDealsData {
		storeCode: string;
		dealNumber: string;
		id: string; // Deal ID.
		dealKind: DealKind; // Either QUOTE or DEAL.
		isDealCreatedInDB: boolean;
	}
</script>
<script setup lang="ts">
	import { computed, inject, nextTick, onBeforeMount, onBeforeUnmount, ref, useTemplateRef, watch } from 'vue';
	import { CreateDeal, IsDealOpenable } from '@core/helpers/deals-helper';
	import { useRoute, useRouter } from 'vue-router';
	import util, { EventBusCore } from '@core/services/util';
	import $modal from '@core/services/modal';
	import api from '@core/services/api/_api';
	import auth from '@core/services/auth';
	import { AxiosResponse } from 'axios';
	import ENUMS from '@core/classes/Enums';
	import FIMenu from '@/components/FIMenu.vue';
	import FIMenuCustomer from '@core/classes/FIMenuCustomer';
	import LogRocket from 'logrocket';
	import modalCountdown from '@/modals/modalCountdown.vue';
	import settings from 'settings';
	import TabMenu from '@/components/TabMenu.vue';

	//import AccordionCustomerQuotes from "@core/components/accordions/AccordionCustomerQuotes";
	import CoBrowsingWrapper from '@/components/CoBrowsing/CoBrowsingWrapper.vue';
	import CustomerDetails from '@/components/CustomerDetails.vue';
	import CustomerDetailsHeader from '@/components/CustomerDetailsHeader.vue';
	import CustomerRecord from '@core/classes/Customer/CustomerRecord';
	import CustomerSearchResult from '@core/classes/CustomerSearchResult';
	import { DealKind } from '@core/classes/SharedEnums';
	import { Emitter } from 'mitt';
	import FIMenuClass from '@core/classes/FIMenu';
	import FIMenuLogItem from '@core/classes/FIMenuLogItem';
	import { GetDeal } from '@core/helpers/deals-helper';
	import IsBusyScreenComponent from '@core/components/IsBusyScreenComponent.vue';
	import IsBusySectionComponent from '@core/components/IsBusySectionComponent.vue';
	import { SaturnGlobalPlugin } from '@core/classes/StaticClasses';
	import StoreClass from '@core/classes/Store/Store';

	const $meetingHub = inject<any>('$meetingHub');
	const $global = inject<SaturnGlobalPlugin>('$global');
	const $route = useRoute();
	const $router = useRouter();
	const EventBus = inject<Emitter<any>>('EventBus');

	const tabMenuRef = useTemplateRef('tabMenu');
	const fimenuDealRef = useTemplateRef('fimenudeal');

	const fimenu = ref(null as FIMenuClass);
	const tabs = ref(['customer']);
	const isZipLookupBusy = ref(false);
	const editingCustomerId = ref(null);
	const selectedCustomerId = ref(null);
	/** Active customer in the page. Could be the main cusomter or could be the edidint customer) */
	const customer = ref(new FIMenuCustomer());
	const personTypes = ref([
		{ code: false, description: 'Person' },
		{ code: true, description: 'Company' },
	]);
	const isLoading = ref(false);
	const isLoadingInitialSetup = ref(false);
	const isCreatingDeal = ref(false);
	const isCreating = ref(false);
	const metadata = ref({
		storeCode: null,
		isSpectator: false,
		store: null,
		buyersOrderEnabled: false,
	});
	const selectedStoreCode = ref(null);
	const customerStores = ref([]);
	const selectedStore = ref(null);
	const legalTermsToBeAgreedTo = ref([]);
	const deals = ref([]);
	const maxDealsInTab = ref(5);
	const availableCustomers = ref([]);
	const isLoadingTabChange = ref(false);
	const isLoadingDeal = ref(false);
	const inactivityTime = ref(0);
	const lockedOut = ref(false);
	const inactivityTimeout = ref(null);
	const inactivityApplyTime = ref(600);

	const canIgnoreInactivityLockout = computed((): boolean => lockedOut.value || $meetingHub.code || settings.environmentName === 'DEVELOPMENT');
	const userStores = computed((): StoreClass[] => settings.userStores);
	const buyersOrdersEnabled = computed((): boolean => selectedStore.value?.storeSettings.buyersOrderEnabled);

	/** If we have more than one customer. That means we're editing; else we are creating. */

	const isCustomerCreating = computed((): boolean => availableCustomers.value.length <= 0);
	const payload = computed(() => auth.getTokenPayload());
	const isCoBrowsingEnabled = computed((): boolean => fimenu.value.store?.storeSettings?.isDealCoBrowsingEnabled ?? false);

	const coBrowsingDataToWatch = computed((): unknown => {
		if (!fimenu.value || !isCoBrowsingEnabled.value) return null;

		return {
			actualCost: fimenu.value.actualCost,
			buyersOrders: fimenu.value.getCurrentBuyersOrder(),
			carFax: fimenu.value.carFax,
			coCustomer: { ...fimenu.value.coCustomer, customerApplication: null },
			coverageTerms: fimenu.value.coverageTerms,
			customer: { ...fimenu.value.customer, customerApplication: null },
			customerApplication: fimenu.value.customerApplication,
			dealAddresses: fimenu.value.dealAddresses,
			dealAddressesQuestions: fimenu.value.dealAddressesQuestions,
			dealJacket: fimenu.value.dealJacket,
			dealDate: fimenu.value.dealDate,
			dealType: fimenu.value.dealType,
			dealStatus: fimenu.value.dealStatus,
			employees: fimenu.value.employees,
			externalDMSDealNumber: fimenu.value.externalDMSDealNumber,
			fees: fimenu.value.fees,
			hasCoSigner: fimenu.value.hasCoSigner,
			hasOtherTradeIns: fimenu.value.hasOtherTradeIns,
			insurance: fimenu.value.insurance,
			invoice: fimenu.value.invoice,
			inventoryType: fimenu.value.inventoryType,
			language: fimenu.value.language,
			leaseTerms: fimenu.value.leaseTerms,
			lender: fimenu.value.lender,
			loanTerms: fimenu.value.loanTerms,
			msrp: fimenu.value.vehicle.getMSRP(),
			otd: fimenu.value.otd,
			otdBase: fimenu.value.otdBase,
			otdFinal: fimenu.value.otdFinal,
			paperworkStatus: fimenu.value.paperworkStatus,
			paperworkPacket: fimenu.value?.paperwork?.currentPacket(),
			preloads: fimenu.value.preloads,
			rebates: fimenu.value.rebates,
			stockNumber: fimenu.value.stockNumber,
			tradeIns: fimenu.value.tradeIns,
			totalSelectedProducts: fimenu.value.totalSelectedProducts,
			totalSelectedPackages: fimenu.value.totalSelectedPackages,
			totalProductProfit: fimenu.value.totalProductProfit,
			vehicle: fimenu.value.vehicle,
			vehicleMiles: fimenu.value.vehicleMiles,
			vehicleWarranty: fimenu.value.vehicleWarranty.warranties,
			vin: fimenu.value.vin,
		};
	});

	onBeforeMount(async () => {
		EventBus.emit('checkSeleniumVersion');

		startInactivityInterval();
		window.addEventListener('mousemove', mouseMoveHandler);

		isLoadingInitialSetup.value = true;
		if ($route.query?.customerId != null) {
			selectedCustomerId.value = $route.query.customerId as string;
			await loadSelectedCustomerInformation();
		}

		// Tab to be loaded.
		if (customerStores.value?.length == 1) {
			selectedStoreCode.value = customerStores.value[0];
			metadata.value.storeCode = selectedStoreCode.value;
			metadata.value.store = settings.userStores.find((x: StoreClass) => x.storeCode == selectedStoreCode.value);
			selectedStore.value = settings.userStores.find((x: StoreClass) => x.storeCode == selectedStoreCode.value);
		}

		watch(
			() => deals.value,
			() => {
				deals.value.forEach((deal: any) => {
					if (!tabs.value.includes(deal.id)) {
						tabs.value.push(deal.id);
					}
				});
			},
			{ deep: true, immediate: true },
		);

		watch(
			() => customer.value.id,
			(newCustomerId: string) => {
				if (customer.value.id != null && customer.value.id != 'null') {
					// When we change the customer id; to an actual customer.
					util.setQueryParm('customerId', newCustomerId, $router);

					if (availableCustomers.value.length <= 0) {
						// If there's no availableCustomers that means it is a new customer.
						addMainCustomerToListOfAvailableCustomers();
						selectedCustomerId.value = customer.value.id;
					}
				}
			},
		);

		// If we're loading straight into a deal, lets load it.
		if ($route.query?.t != null && $route.query?.t != 'customer') {
			const loaded = await handleLoadDeal($route.query?.t as string, getDealTypeFromQuery());
			if (!loaded) $router.push('/customers'); // If we can't find the deal. Kick back to customers page.
		}

		await loadDealIntoTabSystem();

		// nextTick ensures the deals are set (if any) before we actually render the tabMenu.
		// Else, it would not be able to go back to the tabs, as it will be initialized in with default tabs only.
		nextTick(async () => {
			isLoadingInitialSetup.value = false;
			await loadCustomerInfoFromDeals();
			addMainCustomerToListOfAvailableCustomers();
		});

		setupEventListeners();
	});

	onBeforeUnmount(() => {
		window.removeEventListener('mousemove', mouseMoveHandler);
		clearInterval(inactivityTimeout.value);

		EventBusCore.off('deal-saved', dealSavedEmitterHandler);
		EventBusCore.off('VideoRecordingsFImenuLog', videoRecordingsLogs);
		EventBusCore.off('createNewQuoteEvent', createNewQuoteEventEmitterHandler);

		EventBus.off('deal-saved', handleDealSave);
		EventBus.off('switchCustomerTab', handleRequestSwitchCustomerTab);
		EventBus.off('updateCustomer', handleCustomerUpdate);

		videoRecordingHandler(false);
	});

	function setupEventListeners() {
		EventBusCore.on('deal-saved', dealSavedEmitterHandler);
		EventBusCore.on('VideoRecordingsFImenuLog', videoRecordingsLogs);
		EventBusCore.on('createNewQuoteEvent', createNewQuoteEventEmitterHandler);

		EventBus.on('deal-saved', handleDealSave);
		EventBus.on('switchCustomerTab', handleRequestSwitchCustomerTab);
		EventBus.on('updateCustomer', handleCustomerUpdate);
	}

	function mouseMoveHandler() {
		inactivityTime.value = 0;
	}

	function startInactivityInterval() {
		if (canIgnoreInactivityLockout.value) return;

		inactivityTimeout.value = setInterval(() => {
			if (canIgnoreInactivityLockout.value) return;

			inactivityTime.value++;
			if (inactivityTime.value >= inactivityApplyTime.value) {
				lockedOut.value = true;
				openInactivityModal();
			}
		}, 1000);
	}

	function openInactivityModal() {
		clearInterval(inactivityTimeout.value);

		$modal.open(modalCountdown, {
			name: 'modalCountdown',
			passedData: {
				title: 'Inactivity Lock Out',
				info: 'You have been inactive for a while. For security reasons, we will automatically lock you out from this deal.',
				additionalInfo: 'You will be locked out when the timer expires unless you respond.',
				cancelText: "I'm Still Here",
				cancelTextClass: 'button-save hint-click',
				timerDuration: 20,
			},
			cancelFunction: () => {
				lockedOut.value = false;
				inactivityTime.value = 0;
				startInactivityInterval();
			},
			postFunction: () => {
				clearInterval(inactivityTimeout.value);
				lockedOut.value = false;
				inactivityTime.value = 0;
				$router.push('/fimenudeals');
			},
		});
	}

	function videoRecordingsLogs(logInfo: FIMenuLogItem) {
		fimenu.value.addToLog(logInfo.where, logInfo.how, logInfo.what);
	}

	function createNewQuoteEventHandler(event: Event) {
		event.stopPropagation();
		if (deals.value.length >= maxDealsInTab.value) {
			return util.modalInformation(`You have reached the maximum tabs limit (${maxDealsInTab.value}). Please close one before creating a new deal.`);
		} else {
			if (isCreatingDeal.value) {
				return util.modalInformation(`Is a deal being created. Please wait for this process to finish before try again.`);
			}
			handleCreateDeal();
		}
	}

	async function handleDealSave(deal: FIMenuClass) {
		const dealId = deal.id;

		// Getting the deal information for our tabs.
		const tabDealInfoIndex = deals.value.findIndex(d => d.id == dealId);

		if (tabDealInfoIndex >= 0) {
			if (deals.value[tabDealInfoIndex].isDealCreatedInDB == false) {
				deals.value[tabDealInfoIndex].isDealCreatedInDB = true;
			}

			if (deal.buyersOrderEnabled) {
				// This will sync wether the deal is a quote or a deal.
				deals.value[tabDealInfoIndex].dealKind = deal.dealKind;
			}
		}
	}

	function getDealTypeFromQuery(): DealKind {
		return $route.query.dk != null ? (parseInt($route.query.dk as string) as DealKind) : DealKind.Deal;
	}

	function afterTabChange(currentTab: any) {
		videoRecordingHandler(false);

		console.log('CURRENT TAB', currentTab);

		// This code partition handles adding wether the deal is Quote or Deal in the query parameters

		// If the current tab is "customer", remove the query parameter "dk"
		if (currentTab == 'customer') return util.deleteQueryParam('dk');
		// Find the deal that matches the current tab ID
		const dealAboutToBeOpened = deals.value.find(x => x.id == currentTab);
		// If no deal is found, exit the function
		if (!dealAboutToBeOpened) return;
		// Set the query parameter "dk" to the deal kind of the deal about to be opened
		util.setQueryParm('dk', dealAboutToBeOpened.dealKind.toString(), $router);
	}

	function currentTab(): string | null {
		return tabMenuRef.value.activeTab;
	}

	function choosePreselectedStore(): string | null {
		const { userStores } = settings;
		const hasAccessToOneStore = userStores.length === 1;
		const allStoresAreSame = deals.value.length > 0 && deals.value.every(deal => deal.storeCode === deals.value[0].storeCode);

		selectedStoreCode.value = null;

		if (allStoresAreSame) {
			return deals.value[0].storeCode;
		}

		if (hasAccessToOneStore) {
			return userStores[0].storeCode;
		}

		return null;
	}

	function dealSavedEmitterHandler(deal: any) {
		handleDealSave(deal as FIMenuClass);
	}

	function createNewQuoteEventEmitterHandler(event: any) {
		createNewQuoteEventHandler(event as Event);
	}

	/** This
	 * method will add customers to the array of available customers which will display in the dropdown. */
	function addCustomersToAvailableCustomers(customersToAdd: (CustomerSearchResult | CustomerRecord)[] = []) {
		const newCustomers = customersToAdd
			.filter(customer => !availableCustomers.value.some(x => x.id == customer.id)) // Filter customers that already exist in the array.
			.map(customer => ({
				id: customer.id,
				fullName: customer.fullName.toUpperCase(),
				storeCodes: customer.storeCodes,
			}));

		availableCustomers.value.push(...newCustomers);
	}

	/** This metho
	 *  will fetch and load the bare minimum information for the customers in the deals opened. (fullname, customerId, storeCode) */
	async function loadCustomerInfoFromDeals() {
		const response: AxiosResponse<Record<string, CustomerSearchResult[]>> = await api.fimenu.getCustomersInfoFromDeal(deals.value);

		if (response.data) {
			for (const [key, value] of Object.entries(response.data)) {
				const dealId = key;

				if (value?.length ?? 0 > 0) {
					// If we have customers to add from the api call
					addCustomersToAvailableCustomers(value);
				} else {
					// If the deal doesn't have customer. Lets create them
					const response = await api.fimenu.getDeal(dealId);
					if (response.data?.fimenu) {
						const deal = new FIMenuClass(response.data.fimenu);
						await deal.upsertCustomers();
						await deal.saveCustomers();
					}
				}
			}
		}
	}

	/**
	 * This method will load the deal into the tabs system; getting any required information from the id.
	 * Additionally will load all the customers from that deal.
	 *
	 */
	async function loadDealIntoTabSystem() {
		const possibleDealId = $route.query.dealId ?? $route.query.t; // This could be the deal id or the tab.

		const dealId = possibleDealId != null && possibleDealId != 'customer' ? possibleDealId : null;
		// const type = $route.query.dealType ?? DealKind.Deal
		const type = $route.query.dk != null ? (parseInt($route.query.dk as string) as DealKind) : DealKind.Deal;

		let dealNumber = $route.query.dealNumber as string;
		let storeCode = $route.query.storeCode as string;

		const isSelectedTabADeal = dealId != tabs.value[0];

		if ((!dealNumber || !storeCode) && dealId) {
			// If we don't have storecode or deal number. Lets get it.

			if (fimenu.value && fimenu.value.storeCode && fimenu.value.dealNumber) {
				storeCode = fimenu.value.storeCode;
				dealNumber = fimenu.value.dealNumber;
			} else {
				const response = await api.fimenu.getDeal(dealId, type);

				if (response.data?.fimenu) {
					storeCode = response.data.fimenu.storeCode;
					dealNumber = response.data.fimenu.dealNumber;
				}
			}
		}

		if (dealNumber && dealId && storeCode && isSelectedTabADeal) {
			// If we have the deal in teh list, lets not add it. ### FAILSAFE (only happened with hot-reload.)
			if (deals.value.some(x => x.id == dealId)) return;

			deals.value.push({
				storeCode,
				dealNumber,
				id: dealId as string,
				dealKind: type,
				isDealCreatedInDB: true,
			});

			// If the tab parameter is different than "customer"
			if (!util.isNullOrEmpty(dealId) && isSelectedTabADeal) {
				util.deleteQueryParam('dealId');
				util.setQueryParm('t', dealId as string, $router);
				util.setQueryParm('dk', type.toString());
				tabs.value.push(dealId as string);
			}
		}
	}

	function addMainCustomerToListOfAvailableCustomers() {
		if (customer.value.id) {
			availableCustomers.value = availableCustomers.value.filter(x => x.id != customer.value.id);

			availableCustomers.value.push({
				id: customer.value.id,
				fullName: customer.value?.getPaperworkName()?.toUpperCase() || customer.value.fullName,
				storeCodes: [],
			});
		}
	}

	async function handleCustomerUpdate(customerId: string) {
		selectedCustomerId.value = customerId;
		await loadSelectedCustomerInformation();
	}

	async function loadSelectedCustomerInformation() {
		isLoading.value = true;
		try {
			const { data: retrievedCustomer } = await api.customers.getCustomerById(selectedCustomerId.value);

			customer.value = new FIMenuCustomer();
			if (retrievedCustomer) {
				customer.value.setFromCustomer(retrievedCustomer);
				// Add the customer to the input rich dropdown. This method checks if the customer already exists and determines if it needs to be added.
				addCustomersToAvailableCustomers([retrievedCustomer]);
				// Hide stores that the FIManager doesnt have access to.
				customerStores.value = retrievedCustomer.storeCodes.filter((customerStoreCode: string) => {
					return settings.userStores.find((store: StoreClass) => store.storeCode == customerStoreCode);
				});

				await customer.value.loadCustomerData(); // Loads credit report.
			}

			if (selectedStoreCode.value) {
				metadata.value.storeCode = selectedStoreCode.value;
				metadata.value.store = settings.userStores.find((x: StoreClass) => x.storeCode == selectedStoreCode.value);
				metadata.value.buyersOrderEnabled = metadata.value.store.storeSettings.buyersOrderEnabled;
				selectedStore.value = metadata.value.store;
			}

			await customer.value.getAndSetCustomerApplication();
		} catch (error: any) {
			util.toastr('error', 'Retrieving Customer', error.message || error);

			console.error(error);
		} finally {
			isLoading.value = false;
		}
	}

	function handleRequestSwitchCustomerTab({ tabName, customerId, storeCode }: { tabName: string; customerId?: string; storeCode?: string }) {
		// This gets executed from within a deal.
		if (customerId == null) {
			util.deleteQueryParam('customerId');
		} else {
			util.setQueryParm('customerId', customerId, $router);
		}

		if (storeCode != null) {
			selectedStoreCode.value = storeCode;
		}

		if (customerId == 'null') selectedCustomerId.value = null;
		else selectedCustomerId.value = customerId;

		switchTab(tabName); // Should technically be the last one.
	}

	function beforeTabChange(previousTab?: string, tabName?: string) {
		const isloading = dealLoading();

		if (isloading) util.modalInformation('Please wait until the deal is finished loading.');
		else changeTabHandler(previousTab, tabName);

		return !isloading;
	}

	async function changeTabHandler(previousTab: string, newTab: string) {
		isLoadingTabChange.value = true;
		try {
			let clearCustomer = true;

			if (selectedCustomerId.value == 'null') {
				selectedCustomerId.value = null;
			}
			util.deleteQueryParam('customerId');

			if (newTab == 'customer') {
				await loadCustomerInfoFromDeals();

				availableCustomers.value = availableCustomers.value.filter(x => x.id != customer.value.id);

				if (selectedCustomerId.value) {
					// Actually want to edit an user.
					clearCustomer = false;
					await loadSelectedCustomerInformation();
				}
				selectedStoreCode.value = choosePreselectedStore();

				fimenu.value = null; // Clear the deal everytime we leave a deal.
			} else {
				// If we're loading a deal
				// If we're switching between deals; we must clear the FIMenu so we may load it again.
				if (previousTab != 'customer') {
					fimenu.value = null;
				}
				// We only fetch deals when we don't have it.
				// We MIGHT have it when we create a new deal, because it's passed in as memory.
				if (!fimenu.value) {
					// Only fetch if we don't have it.
					const dealInfo = deals.value.find(deal => deal.id == newTab);
					if (dealInfo != null) await handleLoadDeal(newTab, dealInfo.dealKind);
				}
			}

			// If the previous tab is not customer. Try to delete all not-elastic saved deals.
			//  Deal to Deals -> Execute
			//  Deal -> Customer Execute
			//  Customer to Deals -> Not Execute (That's when we're actually creating a deal.)
			if (previousTab != 'customer') clearNotSavedDeals();
			if (!clearCustomer) return;

			selectedCustomerId.value = null;
			customer.value = new FIMenuCustomer();
			customerStores.value = [];
		} catch (err) {
			console.error(err);
		} finally {
			isLoadingTabChange.value = false;
		}
	}

	function openDeal(deal: FIMenuClass, type: DealKind) {
		const { storeCode: storeCode, dealNumber: dealNumber, id: id } = deal;

		if (deals.value.some(x => x.id === deal.id)) {
			if (tabMenuRef.value?.switchTab) return switchTab(deal.id);
			else return util.toastr('error', 'Error', 'Deal is already open in a tab.');
		}

		if (deals.value.length >= maxDealsInTab.value) {
			return util.toastr('error', 'Error', 'You may only open 5 deals at a time!');
		}

		if (deals.value.some(x => x.id == deal.id)) return; // If we have the deal in teh list, lets not add it. ### FAILSAFE (only happened with hot-reload.)
		deals.value.push({
			storeCode,
			dealNumber,
			id,
			dealKind: type,
			isDealCreatedInDB: true,
		});
	}

	function clearNotSavedDeals() {
		const dealsNotCreated = deals.value.filter(x => x.isDealCreatedInDB == false);

		dealsNotCreated.forEach(element => {
			const dealIndex = deals.value.findIndex(x => x.id == element.id);
			if (dealIndex >= 0) deals.value.splice(dealIndex, 1);

			const tabsIndex = tabs.value.findIndex(x => x == element.id);
			if (tabsIndex >= 0) tabs.value.splice(tabsIndex, 1);
		});
	}

	function deleteDealConfirmation(deal: IDealsData) {
		util.modalConfirmation('Are you sure you want to close this deal', 'Yes', () => deleteDealTab(deal), 'No', null, 'Confirmation');
	}

	function deleteDealTab(deal: IDealsData) {
		if (dealLoading()) return beforeTabChange();
		const currentTab = tabMenuRef?.value.activeTab;

		const index = tabs.value.findIndex(tab => tab == deal.id);
		if (index >= 0) {
			const isInCurrentTab = tabs.value[index] == currentTab;

			const dealIndex = deals.value.findIndex(dealOfList => dealOfList.id == deal.id);
			tabs.value.splice(index, 1);
			deals.value.splice(dealIndex, 1);

			if (isInCurrentTab) {
				setTimeout(() => {
					switchTab(tabs.value[0]);
				}, 1);
			}
		}
	}

	function switchTab(tab: string) {
		tabMenuRef.value?.switchTab(tab);
	}

	function dealLoading() {
		if (!fimenuDealRef.value) return false;
		return !!fimenuDealRef.value.isBusyLoadingDeal || isLoadingDeal.value;
	}

	async function createCustomer() {
		if (!selectedStoreCode.value) return util.toastr('error', 'Failed', 'You must select a store before you create a customer.');

		try {
			isLoading.value = true;

			const response = await api.customers.createCustomerFromFIMenu(customer.value, selectedStoreCode.value, ENUMS.CUSTOMER_CREATION_SOURCE.CustomersPage);
			util.toastr('success', 'Success', `Customer ${!customer.value.id ? 'Created' : 'Saved'}`);

			//Set the customer id. If the customer matched something else on the backend. We would get it; therefor is important to set it.
			if (customer.value.id != response.data.id) {
				customer.value.id = response.data.id;
				$router.replace({ query: { id: customer.value.id } });
			}

			// Update associated stores.
			const customerStores = response.data.storeCodes;
			const userStores = settings.userStores;

			customerStores.value = customerStores.filter((storeCode: string) => userStores.find((store: StoreClass) => store.storeCode == storeCode));
			LogRocket.track(`Cust_Created`, {
				customerId: customer.value.id,
				customerCell: customer.value.cell,
				customerEmail: customer.value.email,
				customerDob: customer.value.dob,
				storeName: $global.selectedStore.storeName,
				environment: settings.environmentName,
			});
		} catch (err) {
			console.error(err);
			util.toastr('error', 'Error', 'Customer could not be created.');
		} finally {
			isLoading.value = false;
		}
	}

	function handleGoBack() {
		util.modalConfirmation('Are you sure you want to go back?', 'Yes', () => $router.push('/customers'), 'No', null, 'Confirmation');
	}

	function videoRecordingHandler(startRecording = true) {
		if (fimenu.value?.store?.storeSettings?.isScreenRecordingEnabled) {
			if (startRecording) {
				//Start video recording if Store Settings is set to true
				fimenu.value.currentRecordingVideo = util.getGuid();
				EventBusCore.emit('startVideoRecording', {
					videoId: fimenu.value?.currentRecordingVideo,
					fimenuId: fimenu.value.id,
					dealNumber: fimenu.value.dealNumber,
					store: fimenu.value?.store,
				});
			} else {
				//stop the video recording when tab is changed to have it ready for next record
				//(funciton handles if the recording is happening or not)
				const resetCurrentRecordingVideoId = () => {
					fimenu.value.currentRecordingVideo = null;
				};
				EventBusCore.emit('stopVideoRecording', resetCurrentRecordingVideoId);
			}
		}
	}

	async function handleCreateDeal(coCustomer: FIMenuCustomer = null) {
		// Takes in a customer search result
		isCreatingDeal.value = true;

		try {
			const deal = await CreateDeal(customer.value, metadata.value.storeCode, coCustomer);

			if (deal != null) {
				fimenu.value = deal;
				// Add the deal to the tab, save it into local storage and switch to the newly added deal.
				deals.value.push({
					storeCode: deal.storeCode,
					dealNumber: deal.dealNumber,
					id: deal.id,
					dealKind: deal.dealKind,
					isDealCreatedInDB: false,
				});

				videoRecordingHandler();

				switchTab(deal.id); // Should technically be the last one.
			}

			$modal.cancel();
		} catch (err: any) {
			util.toastr('error', 'Error saving', err.message ?? 'Unexpected server error occured. Please refresh and try again.');
		} finally {
			isCreatingDeal.value = false;
		}
	}

	/**
	 * Loads a deal based on the given deal ID and type.
	 *
	 * @param {string} dealId - The ID of the deal to load.
	 * @param {DealKind} dealType - The type of the deal (either Quote or Deal).
	 * @returns {Promise<void>} - A promise that resolves when the deal is loaded.
	 *
	 */
	async function handleLoadDeal(dealId: string, dealType: DealKind = DealKind.Deal) {
		// DO NOT add logic here; UNLESS is specific for customer/deals.
		isLoadingDeal.value = true; // Indicate that the deal is currently loading.
		fimenu.value = null; // Reset the fimenu property before loading a new deal.

		// Fetch the deal using the provided ID and type.
		let deal = await GetDeal(dealId, dealType);
		let canLoad = false;
		// Check if the deal is loadable based on its type.
		if (deal) {
			canLoad = IsDealOpenable(deal, dealType);
		}

		// If the deal cannot be loaded, attempt to fetch a fallback deal.
		if (!canLoad) {
			let lookupKind = dealType;
			// Determine the kind of deal to look up based on the current deal type.
			if (dealType == DealKind.Quote) {
				lookupKind = DealKind.Deal; // Fallback to Deal if the current type is Quote.
			}
			if (dealType == DealKind.Deal) {
				lookupKind = DealKind.Quote; // Fallback to Quote if the current type is Deal.
			}

			// Attempt to fetch the fallback deal.
			const fallbackDeal = await GetDeal(dealId, lookupKind);

			// If a fallback deal is found, use it.
			if (fallbackDeal) {
				$router.push({
					query: {
						...$route.query,
						dk: lookupKind.toString(),
					},
				});
				deal = fallbackDeal;
			}
		}

		if (deal) {
			fimenu.value = deal; // Get deal is already trycatching.
			videoRecordingHandler();
		} else {
			util.toastr('error', 'Error', 'There was an error loading the deal, please try refreshing the page.');
			switchTab(tabs.value[0]);
		}
		isLoadingDeal.value = false;

		return !!fimenu.value;
	}
</script>
<style>
	.customer {
		padding-bottom: 150px;
		box-sizing: border-box;
	}

	.customer .customer-body {
		display: flex;
		flex-direction: column;
		width: 100%;
		align-items: center;
		margin: 0 auto;
	}

	.page.customer .buttons-container {
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: flex-end;
	}

	.page.customer {
		/* One side has more padding to make up to the built in css in the other side, if that makes any sense. */
		padding: 15px 5px 0px 5px;
		box-sizing: border-box;
		height: 100%;
		overflow: hidden;
	}

	.page.customer .button-save .create-quote {
		min-width: 120px;
	}

	.page.customer .tabmenu-container {
		height: 100%;
	}

	.page.customer .tabmenu-container ul.tabmenu-menu {
		height: 100%;
	}

	.tabmenu-container .tabmenu-main {
		height: 100%;
		box-sizing: border-box;
	}

	.tabmenu-container .tabmenu-panel:has(.fimenupage) {
		height: calc(100% - 40px);
	}

	.storesListContainer {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	.floating-menu-button {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		font-size: 14px !important;
	}

	.remove-button-style {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		color: black;
		background-color: unset;
		border: unset;
		box-shadow: unset !important;
		max-width: 120px;
		padding: 0;
		gap: 10px;
		box-sizing: border-box;
	}

	.customer .FloatingMenu .menu {
		min-width: 200px;
	}

	.tabmenu-panel:has(.customer-header) {
		display: grid;
		grid-template-rows: auto 1fr;
	}

	.tabmenu-panel.tab-body--active {
		height: 100%;
	}

	.tabmenu-panel .customer-body {
		padding: 10px 20px;
		box-sizing: border-box;
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.customer .accordionBodyContainer {
		padding: 0.5% 1% !important;
	}

	.customer-footer {
		display: flex;
		width: 100%;
		height: 65px;
		justify-content: flex-end;
		align-items: center;
		padding: 10px;
		box-sizing: border-box;
	}

	.page.customer .customer-body .fi-customer-menu-deals .children-container {
		min-height: unset;
	}

	.admin-view-data {
		position: absolute;
		font-size: 12px;
		right: 25px;
		display: flex;
		flex-direction: column;
	}

	.page.customer .tabmenu-container .tabmenu-main:has(.page.fimenupage) {
		padding: unset;
	}
</style>
